module.exports = __webpack_public_path__ + "static/img/leaf2@3x.e5ca78c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dominos-assets/leaf2@3x.png
// module id = DtFf
// module chunks = 0